import { PreScreeningQuestion } from "../../../types/landingPage";

export interface RecognizedMedication {
  name: string;
  genericName?: string;
  brandNames?: string[];
  category?: string;
  status: "current" | "past" | "stopped" | "never";
  confidence: number;
  matchedText: string;
  // For mapping to the grid format
  gridValue?: string;
}

export interface MedicationCategory {
  category: string;
  medications: string[];
  disqualifyIfCurrent?: boolean;
  disqualifyWithin?: string;
  timeframes?: Record<string, string>;
  excludes?: string[];
}

export interface ClarificationRequest {
  originalText: string;
  suggestedQuestion: string;
}

export interface MedicationAIResponse {
  medications: RecognizedMedication[];
  needsClarification?: ClarificationRequest[];
  rawText: string;
}

// Updated types for validation agent
export interface ClinicalDecisionResponse {
  decision: "pass" | "fail";
  reasoning: string;
  confidence?: number;
  flaggedMedications: {
    medication: RecognizedMedication;
    reason: string;
    ruleApplied: string;
  }[];
}

export interface ValidationRequest {
  medications: RecognizedMedication[];
  businessDecision: ClinicalDecisionResponse;
  studyContext: string;
  medicationCategories: MedicationCategory[];
}

export interface ValidationResponse {
  validation: "confirmed" | "concern" | "review_needed";
  confidence: number;
  concerns: string[];
  recommendations: string[];
  suggestedAction: "proceed" | "ask_user_to_clarify" | "manual_review";
  reasoning: string;
}

export interface AIMedicationEntryProps {
  question: PreScreeningQuestion;
  value: string | string[];
  onAnswer: (questionId: string, value: string | string[]) => void;
  onDisqualify?: (message: string) => void;
  allowBack?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  // Tracking context properties
  landingPageId?: string;
  variantId?: string;
  masterId?: string;
  prescreenerId?: string;
}

export enum AIStatus {
  IDLE = "idle",
  TYPING = "typing",
  PROCESSING = "processing",
  CONFIRMING = "confirming",
  VALIDATING = "validating", // Changed from EVALUATING
  ERROR = "error",
  COMPLETE = "complete",
}